(function () {
  document.querySelectorAll('.giveaway-landing').forEach(function (root) {
    if (root.dataset.giveawayInitialized === 'true') return;
    root.dataset.giveawayInitialized = 'true';

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var giveawayName = root.getAttribute('data-giveaway-name') || '';
    var statusAnnouncer = root.querySelector('[data-status-announcer]');

    function announce(text) {
      if (statusAnnouncer) statusAnnouncer.textContent = text;
    }

    /* ---------- smooth scroll ---------- */
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-scroll-target]');
      if (!trigger) return;
      var targetSelector = trigger.getAttribute('data-scroll-target');
      var target = targetSelector ? document.querySelector(targetSelector) : null;
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });

    /* ---------- accessible disclosure ---------- */
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-disclosure-trigger]');
      if (!trigger) return;
      var controlsId = trigger.getAttribute('aria-controls');
      var body = controlsId ? document.getElementById(controlsId) : null;
      if (!body) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
    });

    /* ---------- social CTA click tracking (never blocks navigation) ---------- */
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-social]');
      if (!link) return;
      var platform = link.getAttribute('data-social');
      var location = link.getAttribute('data-cta-location') || 'unknown';
      var eventName = platform === 'instagram' ? 'maieway_instagram_bonus_cta_click' : 'maieway_tiktok_bonus_cta_click';
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: {
          cta_location: location,
          giveaway_name: giveawayName,
          destination_platform: platform
        }
      }));
    });

    /* ---------- sticky mobile CTA ---------- */
    var stickyCta = root.querySelector('[data-sticky-cta]');
    var stickyDefault = root.querySelector('[data-sticky-cta-default]');
    var stickySocial = root.querySelector('[data-sticky-cta-social]');
    var formSection = root.querySelector('[data-giveaway-form-section]');
    var successCard = root.querySelector('[data-success-card]');

    if (stickyCta && formSection && 'IntersectionObserver' in window) {
      var formVisible = false;
      var successVisible = false;

      function updateStickyVisibility() {
        stickyCta.hidden = formVisible || successVisible;
      }

      var formObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          formVisible = entry.isIntersecting;
          updateStickyVisibility();
        });
      }, { threshold: 0.1 });
      formObserver.observe(formSection);

      if (successCard) {
        var successObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            successVisible = entry.isIntersecting && !successCard.hidden;
            updateStickyVisibility();
          });
        }, { threshold: 0.1 });
        successObserver.observe(successCard);
      }
    }

    function showPostSuccessStickyCta() {
      if (!stickyCta) return;
      if (stickyDefault) stickyDefault.hidden = true;
      if (stickySocial) stickySocial.hidden = false;
    }

    /* ---------- Klaviyo client API helpers ----------
       Public Client API — authenticated only by the public company_id query
       param, never a private key. See https://developers.klaviyo.com/en/reference/client_api_overview
       Verify the exact revision/payload shape against current Klaviyo docs
       during the first live test submission. */
    var KLAVIYO_REVISION = '2026-07-15';

    function klaviyoRequest(companyId, path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      });
    }

    function createProfile(companyId, email, firstName, properties) {
      return klaviyoRequest(companyId, 'profiles', {
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: firstName,
            properties: properties
          }
        }
      });
    }

    function createEvent(companyId, email, properties) {
      return klaviyoRequest(companyId, 'events', {
        data: {
          type: 'event',
          attributes: {
            properties: properties,
            time: new Date().toISOString(),
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Giveaway Entry' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          }
        }
      });
    }

    function subscribeProfile(companyId, listId, email, firstName) {
      return klaviyoRequest(companyId, 'subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  subscriptions: {
                    email: {
                      marketing: { consent: 'SUBSCRIBED' }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      });
    }

    /* ---------- form handling ---------- */
    var form = root.querySelector('[data-giveaway-form]');
    if (!form) return;

    var submitButton = form.querySelector('[data-submit-button]');
    var formStatus = form.querySelector('[data-form-status]');
    var formCard = root.querySelector('[data-form-card]');

    var requiredFields = Array.prototype.slice.call(form.querySelectorAll('[required]'));

    function clearFieldError(field) {
      field.setAttribute('aria-invalid', 'false');
      var errorEl = document.getElementById(field.getAttribute('aria-describedby'));
      if (errorEl && errorEl.classList.contains('giveaway-landing__field-error')) {
        errorEl.hidden = true;
      }
    }

    function showFieldError(field) {
      field.setAttribute('aria-invalid', 'true');
      var describedBy = (field.getAttribute('aria-describedby') || '').split(' ');
      describedBy.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.classList.contains('giveaway-landing__field-error')) {
          el.hidden = false;
        }
      });
    }

    requiredFields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.checkValidity()) clearFieldError(field);
      });
      field.addEventListener('change', function () {
        if (field.checkValidity()) clearFieldError(field);
      });
    });

    function validateForm() {
      var firstInvalid = null;
      requiredFields.forEach(function (field) {
        if (!field.checkValidity()) {
          showFieldError(field);
          if (!firstInvalid) firstInvalid = field;
        } else {
          clearFieldError(field);
        }
      });
      if (firstInvalid) {
        firstInvalid.focus();
        return false;
      }
      return true;
    }

    function setLoading(isLoading) {
      if (!submitButton) return;
      submitButton.disabled = isLoading;
      submitButton.textContent = isLoading
        ? submitButton.getAttribute('data-loading-label')
        : submitButton.getAttribute('data-default-label');
    }

    function showFormError(message) {
      if (!formStatus) return;
      formStatus.hidden = false;
      formStatus.textContent = message;
    }

    function clearFormError() {
      if (!formStatus) return;
      formStatus.hidden = true;
      formStatus.textContent = '';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearFormError();

      var honeypot = form.querySelector('input[name="website"]');
      if (honeypot && honeypot.value.trim() !== '') {
        /* Likely a bot: silently no-op without revealing the honeypot to a script. */
        return;
      }

      if (!validateForm()) return;

      var companyId = form.getAttribute('data-company-id');
      var listId = form.getAttribute('data-list-id');
      var secondaryListId = form.getAttribute('data-secondary-list-id');
      var giveawaySource = form.getAttribute('data-giveaway-source');
      var successRedirect = form.getAttribute('data-success-redirect');

      var firstName = form.querySelector('[name="first_name"]').value.trim();
      var email = form.querySelector('[name="email"]').value.trim();
      var hairType = form.querySelector('[name="hair_type"]').value;
      var hairThickness = form.querySelector('[name="hair_thickness"]').value;
      var hairDensity = form.querySelector('[name="hair_density"]').value;
      var hairGoal = form.querySelector('[name="hair_goal"]').value;
      var discoverySource = form.querySelector('[name="discovery_source"]').value;

      var instagramBonusEl = form.querySelector('[name="instagram_bonus"]');
      var tiktokBonusEl = form.querySelector('[name="tiktok_bonus"]');
      var purchaseBonusEl = form.querySelector('[name="purchase_bonus"]');
      var marketingConsentEl = form.querySelector('[name="marketing_consent"]');

      var instagramBonus = !!(instagramBonusEl && instagramBonusEl.checked);
      var tiktokBonus = !!(tiktokBonusEl && tiktokBonusEl.checked);
      var purchaseBonus = !!(purchaseBonusEl && purchaseBonusEl.checked);
      var marketingConsent = !!(marketingConsentEl && marketingConsentEl.checked);

      var bonusEntryCount = (instagramBonus ? 1 : 0) + (tiktokBonus ? 1 : 0) + (purchaseBonus ? 1 : 0);

      var properties = {
        'Hair Type': hairType,
        'Hair Strand Thickness': hairThickness,
        'Hair Density': hairDensity,
        'Primary Hair Goal': hairGoal,
        'Maiéway Discovery Source': discoverySource,
        'Giveaway Name': giveawayName,
        'Giveaway Entry Date': new Date().toISOString(),
        'Giveaway Entry Source': giveawaySource,
        'Instagram Bonus Entry': instagramBonus,
        'TikTok Bonus Entry': tiktokBonus,
        'Market Purchase Bonus Entry': purchaseBonus,
        'Bonus Entry Count': bonusEntryCount
      };

      setLoading(true);

      createProfile(companyId, email, firstName, properties)
        .then(function (profileRes) {
          if (!profileRes.ok) throw new Error('profile');
          return createEvent(companyId, email, properties);
        })
        .then(function (eventRes) {
          if (!eventRes.ok) throw new Error('event');
          if (marketingConsent) {
            var listIds = [listId, secondaryListId].filter(function (id) { return !!id; });
            return Promise.all(listIds.map(function (id) {
              return subscribeProfile(companyId, id, email, firstName).then(function (subscribeRes) {
                if (!subscribeRes.ok) {
                  return subscribeRes.text().then(function (bodyText) {
                    /* eslint-disable-next-line no-console */
                    console.error('Klaviyo subscribe request failed for list', id, subscribeRes.status, bodyText);
                    throw new Error('subscribe');
                  });
                }
              });
            }));
          }
          return null;
        })
        .then(function () {
          setLoading(false);
          if (formCard) formCard.hidden = true;
          if (successCard) {
            successCard.hidden = false;
            successCard.focus();
          }
          announce("You're in! Your giveaway entry has been received.");
          showPostSuccessStickyCta();

          window.dispatchEvent(new CustomEvent('maieway_giveaway_entry_success', {
            detail: {
              giveaway_name: giveawayName,
              marketing_consent: marketingConsent,
              entry_source: giveawaySource
            }
          }));

          if (successRedirect) {
            window.setTimeout(function () {
              window.location.href = successRedirect;
            }, 1800);
          }
        })
        .catch(function (err) {
          setLoading(false);
          /* eslint-disable-next-line no-console */
          console.error('Giveaway submission failed at step:', err && err.message);
          showFormError('Something went wrong submitting your entry. Please check your connection and try again.');
        });
    });
  });
})();
